(function($) {
    $(document).ready(function(){
        var voucherMessageSelector = 'form.cart .voucher-fields textarea';
        $(voucherMessageSelector).keyup(function () {
            var regex = /[^0-9a-z\ \!\.\,\?\$\%\*\(\)\-\+\{\}\[\]\@\#\~\;\:\\\/\&]/gi;
            this.value = this.value.replace(regex, '');
        });

    });
})(jQuery);